import ComparisonResultTable from './Table';

export default ComparisonResultTable;
